export enum Theme {
  LIGHT = "LIGHT",
  DARK = "DARK"
}
